import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import * as React from 'react';
import onReplyReplyAllInternal from './onReplyReplyAllInternal';

export default function onReply(
    instrumentationContext: InstrumentationContext,
    viewState: ItemViewState,
    item: ClientItem,
    targetWindow: Window
) {
    return (event: React.MouseEvent<HTMLElement>) => {
        onReplyReplyAllInternal(
            false /* isReplyAll */,
            viewState.isConversationItemPart,
            item,
            instrumentationContext,
            targetWindow,
            event
        );
    };
}
